import React,{ Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import moment from 'moment'
import { getPedidoAdmin, pedidoUpdate } from '../actions/admin'
import AdminMenu from '../components/admin_menu'
import CustomPreview from '../containers/custom_preview'
require("moment/locale/es");
 
class AdminPedido extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      stat: 0,
      stats: ["PENDIENTE", "EN PROCESO", "TERMINADO", "ENTREGADO"],
      cargo:false
    };
    moment.locale("es");
    this.estadoChange = this.estadoChange.bind(this)
    this.updateEstado = this.updateEstado.bind(this)
  }

  componentDidMount() {
    if (!this.props.usuario.user) {
      this.props.history.push("/login");
    }
    this.props.getPedidoAdmin(this.props.match.params.id);
  }

  componentDidUpdate(prevProps, prevState) {
    //console.log(this.props.pedidos.pedido)
    if(!this.state.cargo){
      if (this.props.pedidos.pedido.stat != this.state.stat) {
        this.setState({
          stat: this.props.pedidos.pedido.stat,
          cargo:true
        });
      }else{
        this.setState({
          cargo: true
        });
      }

    }
  }

  limpiaCarro() {}

  estadoChange(e) {
    this.setState({ stat: e.target.value });
  }

  updateEstado(e){
    e.preventDefault()
    this.props.pedidoUpdate(this.props.match.params.id,this.state.stat);
  }

  render() {
    moment.locale("es");
    if (
      !this.props.pedidos.pedido ||
      !this.props.pedidos.pedido.hasOwnProperty("contenido")
    ) {
      return <div>CARGANDO</div>;
    }

    var datos_pago = null;
    if (this.props.pedidos.pedido.hasOwnProperty("pago")) {
      datos_pago = Object.keys(this.props.pedidos.pedido.pago).map((k, i) => {
        return (
          <li key={i} className="list-group-item">
            {k + " : " + this.props.pedidos.pedido.pago[k]}
          </li>
        );
      });
    }

    var total = 0;
    var listaCarro = [];
    listaCarro = this.props.pedidos.pedido.contenido.map((producto, i) => {
      total += parseFloat(producto.cantidad) * parseFloat(producto.precio);
      //<td><button type="button" className="btn btn-info" onClick={(e) => this.sacaProducto(i)}>ELIMINAR</button></td>
      return (
        <tr key={i}>
          <td>
            {producto.rubro_nombre} {producto.prod_nombre} {producto.nombre}
          </td>
          <td>{producto.cantidad}</td>
          <td>
            $
            {(
              parseFloat(producto.cantidad) * parseFloat(producto.precio)
            ).toFixed(2)}
          </td>
        </tr>
      );
    });
    var listaCustom = "";

    var listaCustom = this.props.pedidos.pedido.contenido.map((producto, i) => {
      if (producto.hasOwnProperty("custom_objs")) {
        return (
          <li key={i}>
            <CustomPreview producto={producto} />
          </li>
        );
      }
    });

    const estados = this.state.stats.map((stat, i) => {
      return (
        <option value={i} key={i}>
          {stat}
        </option>
      );
    });

    return (
      <div className="container">
        <section className="row mb-5 sombraHead mt-3 clearfix">
          <div className="col-md-3 mb-3">
            <AdminMenu />
          </div>

          <div className="col-md-9 p-3">
            <div className="container">
              <div>
                <h1 className="display-4">Pedido</h1>
              </div>

              <div className="row">
                <h5 className="col-6" style={{ color: "#95c03f" }}>
                  {moment
                    .unix(this.props.pedidos.pedido.fechaunix)
                    .format("DD.MM.YYYY HH:mm")}
                </h5>
                <form>
                  <select
                    className="form-control"
                    id="categoria"
                    value={this.state.id_categoria}
                    onChange={this.estadoChange}
                  >
                    {estados}
                  </select>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={this.updateEstado}
                  >
                    MODIFICAR
                  </button>
                </form>
                {/*<h5 className="col-6 text-right" style={{color:"#95c03f"}}>{this.state.stats[this.props.pedidos.pedido.stat]}</h5>*/}
              </div>

              <div className="row">
                <div className="card col-md-5 m-3">
                  <div className="card-body">
                    <h5 className="card-title">Contacto</h5>
                    <h6 className="card-subtitle mb-2 text-muted">
                      Apellido y Nombre
                    </h6>
                    <p className="card-text">
                      {this.props.pedidos.pedido.contacto.apellido}{" "}
                      {this.props.pedidos.pedido.contacto.nombre}
                    </p>
                    <h6 className="card-subtitle mb-2 text-muted">E-Mail</h6>
                    <p className="card-text">
                      {this.props.pedidos.pedido.contacto.correo}
                    </p>
                    <h6 className="card-subtitle mb-2 text-muted">Telefono</h6>
                    <p className="card-text">
                      {this.props.pedidos.pedido.contacto.telefono}
                    </p>
                    <h6 className="card-subtitle mb-2 text-muted">Empresa</h6>
                    <p className="card-text">
                      {this.props.pedidos.pedido.contacto.empresa}
                    </p>
                    <h6 className="card-subtitle mb-2 text-muted">Usuario</h6>
                    <p className="card-text">
                      {this.props.pedidos.pedido.usuario.correo}
                    </p>
                    <h6 className="card-subtitle mb-2 text-muted">Condición</h6>
                    <p className="card-text">
                      {this.props.pedidos.pedido.contacto.condicion}
                    </p>
                    {this.props.pedidos.pedido.contacto.condicion !=
                      "CONSUMIDORFINAL" && (
                      <React.Fragment>
                        <h6 className="card-subtitle mb-2 text-muted">
                          Cuit/Cuil
                        </h6>
                        <p className="card-text">
                          {this.props.pedidos.pedido.contacto.cuitcuil}
                        </p>
                      </React.Fragment>
                    )}
                  </div>
                </div>

                <div className="card col-md-5 m-3">
                  <div className="card-body">
                    <h5 className="card-title">Destino</h5>
                    <h6 className="card-subtitle mb-2 text-muted">Dirección</h6>
                    <p className="card-text">
                      {this.props.pedidos.pedido.destino.calle}{" "}
                      {this.props.pedidos.pedido.destino.altura}{" "}
                      {this.props.pedidos.pedido.destino.piso}{" "}
                      {this.props.pedidos.pedido.destino.tipo}
                    </p>
                    <h6 className="card-subtitle mb-2 text-muted">Ciudad</h6>
                    <p className="card-text">
                      {this.props.pedidos.pedido.destino.ciudad}
                    </p>
                    <h6 className="card-subtitle mb-2 text-muted">Provincia</h6>
                    <p className="card-text">
                      {this.props.pedidos.pedido.destino.provincia}
                    </p>
                    <h6 className="card-subtitle mb-2 text-muted">Pais</h6>
                    <p className="card-text">
                      {this.props.pedidos.pedido.destino.pais}
                    </p>
                  </div>
                </div>
              </div>

              <div className="row">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">PRODUCTO</th>
                      <th scope="col">CANTIDAD</th>
                      <th scope="col">PRECIO</th>
                    </tr>
                  </thead>
                  <tbody>{listaCarro}</tbody>
                  <thead>
                    <tr>
                      <th scope="col">IVA 21%:</th>
                      <th scope="col" />
                      <th scope="col">${((total * 21) / 100).toFixed(2)}.-</th>
                      <th />
                    </tr>
                    <tr>
                      <th scope="col">
                        {this.props.pedidos.pedido.envio.nombre}
                      </th>

                      <th scope="col" />
                      <th scope="col">
                        ${this.props.pedidos.pedido.envio.costo}.-
                      </th>
                    </tr>
                    <tr>
                      <th scope="col">Total:</th>
                      <th scope="col" />
                      <th scope="col">
                        $
                        {(
                          this.props.pedidos.pedido.envio.costo +
                          (total + (total * 21) / 100)
                        ).toFixed(2)}
                        .-
                      </th>
                      <th />
                    </tr>
                  </thead>
                </table>
              </div>

              {this.props.pedidos.pedido.hasOwnProperty("pago") && (
                <div>
                  {this.props.pedidos.pedido.pago === 0 ? (
                    <h4>NO TENEMOS INFORMACION DEL PAGO</h4>
                  ) : (
                    <React.Fragment>
                      <h4>PAGO</h4>
                      <ul className="list-group">{datos_pago}</ul>
                    </React.Fragment>
                  )}
                </div>
              )}
            </div>
          </div>
        </section>
        {listaCustom && <ul className="listaCustom">{listaCustom}</ul>}
      </div>
    );
  }
}

const mapStateToProps = state => {
	return {
    	pedidos: state.pedidos,
      usuario: state.usuario
  	}
}

const mapDispatchToProps = dispatch => {
  return {
    getPedidoAdmin: (id) => {
      dispatch(getPedidoAdmin(id))
    },
    pedidoUpdate:(id,stat) =>{
      dispatch(pedidoUpdate(id,stat));
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminPedido)




// WEBPACK FOOTER //
// ./src/containers/admin_pedido.js